import type { LibraryWork } from '../interfaces/work';
import type { ComposerWork } from '../services/works';

export const UNKNOWN_COMPOSER = 'Unknown Composer';

export const mapComposerWorkToLibraryWork = (work: ComposerWork): LibraryWork => {
  const base: LibraryWork = {
    id: work.id,
    uri: `cmf:work:${work.id}`,
    type: 'work',
    name: work.title || 'Untitled Work',
    composerName: work.composerName ?? UNKNOWN_COMPOSER,
    composerId: work.composerId,
  };

  if (typeof work.movementCount === 'number') {
    base.movementCount = work.movementCount;
  }

  if (work.imageUrl) {
    base.imageUrl = work.imageUrl;
  }

  if (work.catalogueNumberNormalized) {
    base.catalogueNumberNormalized = work.catalogueNumberNormalized;
  }

  const catalogueLabel =
    work.catalogLabel ?? work.catalogueNumber ?? work.catalogueNumberNormalized;
  if (catalogueLabel) {
    base.catalogueNumber = catalogueLabel;
  }

  return base;
};
